<template>
  <div class="flex items-center gap-2">
    <div class="h-2 flex-1 overflow-hidden rounded-full bg-land-surface-soft">
      <div class="h-full rounded-full transition-[width]" :class="barClasses" :style="{ width: `${safeValue}%` }" />
    </div>
    <span v-if="showLabel" class="w-10 text-right text-xs font-semibold text-land-ink-muted">{{ safeValue }}%</span>
  </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  value: {
    type: Number,
    default: 0
  },
  tone: {
    type: String,
    default: 'green'
  },
  showLabel: {
    type: Boolean,
    default: true
  }
})

const safeValue = computed(() => Math.min(100, Math.max(0, Number(props.value || 0))))

const barClasses = computed(() => ({
  green: 'bg-emerald-500',
  blue: 'bg-blue-500',
  amber: 'bg-amber-500',
  red: 'bg-red-500',
  violet: 'bg-violet-500',
  slate: 'bg-slate-400'
})[props.tone] || 'bg-emerald-500')
</script>
